import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import NoDataFound from "../../Components/NoDataFound";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import moment from "moment";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import Notiflix, { Notify } from "notiflix";
import PostApiCall from "../../Api/Api";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../Helper/Socket";
import { ToastContainer, toast } from "react-toastify";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import { Eye } from "react-feather";
import { delay } from "../../Helper/ToastDelay";
import {useHistory} from 'react-router-dom'


const ManageAudit = () => {
  const [userData, setUserData] = useState();
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profile);
  const tempUser = useSelector((state) => state.login);
  const socket = useSocket();
  const [filteredData, setFilteredData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [jobStatus, setJobStatus] = useState({ value: "All", label: "All" });
  const [loading, setLoading] = useState(false);
  const [getManageAuditData, setManageAuditData] = useState([]);

  const [statusOfAuditor, setStatusOfAuditor] = useState("");
  const [statuschange, setstatuschange] = useState('');

  const history = useHistory()

  const fetchAuditApplied = async () => {
    const resultdes = await PostApiCall.postRequest(
      {
        id: tempUser.fld_id,
      },
      "Job_GetPublishAuditList"
    );
    const { data } = await resultdes.json();
    Notiflix.Loading.remove();
    setFilteredData(data);
    setManageAuditData(data);
  };

  const FetchAppiedUserAudit = async () => {
    const resultdes = await PostApiCall.postRequest(
      {
        publisherid: 0,
        outletid: 0,
        auditorid: tempUser.fld_id,
      },
      "GetAuditRequest"
    );
    const { data } = await resultdes.json();
    Notiflix.Loading.remove();
    setManageAuditData(data);
    setFilteredData(data);
  };

  useEffect(() => {
    Notiflix.Loading.standard();

    if (tempUser.fld_isadmin === 1 || tempUser.fld_usertype === "Staff") {
      fetchAuditApplied();
    } else {
      FetchAppiedUserAudit();
    }
    setLoading(false);
  }, [loading]);

  const filterData = (search, filter) => {
    const filtered = getManageAuditData.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const statusMatches =
        !filter ||
        filter.value === "All" ||
        item.fld_auditstatus === filter.value;
      return searchMatches && statusMatches;
    });
    setFilteredData(filtered);
  };

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearchKeyword(keyword);
    filterData(keyword, jobStatus);
  };

  const handleJobStatusChange = (selectedOption) => {
    setJobStatus(selectedOption);
    filterData(searchKeyword, selectedOption);
  };

  let columnDefs = [
    {
      name: "outlet id",
      selector: (row) => row.fld_outletid,
      width: "150px",
    },
    {
      name: "outlet name",
      selector: (row) => row.fld_outletname,
      width: "150px",
    },
    {
      name: "address",
      selector: (row) => row.fld_address,
      width: "150px",
    },
    {
      name: "city",
      selector: (row) => row.fld_city,
      width: "150px",
    },
    {
      name: "Audit Schedule Date",
      selector: (row) => moment(row.fld_scheduledate).format("ll"),
      width: "200px",
    },
    {
      name: "Audit Proposed Date",
      selector: (row) => moment(row.fld_purposaldate).format("ll"),
      width: "200px",
    },
    {
      name: "Audit Status",
      width: "150px",
      cell: (row) => (
        <span
          className={`${genareteColor(
            row.fld_auditstatus
          )} font-size-3 rounded-3 px-2`}
        >
          {row.fld_auditstatus}
        </span>
      ),
    },
    {
      name: "Auditor Status",
      width: "150px",
      cell: (row) => (
        <span
          className={`${genareteColor(
            row.fld_auditorstatus
          )} font-size-3 rounded-3 px-2`}
        >
          {row.fld_auditorstatus}
        </span>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <span
          className="d-flex align-items-center "
          style={{ cursor: "pointer" }}
          onClick={() => {
            setUserData(row);
            setModal(!modal);
          }}
        >
          <Eye size={16} className="mr-1" /> View
        </span>
      ),
      width: "150px",
    },
  ];

  const GenerateCreditHanlder = (value) => {
    Notiflix.Loading.standard();
    let payload = {
      company_employeeid: user.fld_id[0],
      name: user.fld_name,
      mobile: user.fld_mobile,
      email: user.fld_email,
      usertype: user.fld_usertype,
      auditorid: user.fld_id[1],
      updatedby: user.fld_id[0],
      updatedon: moment().format("ll"),
      gender: user.fld_gender,
      activeupto: value,
      workcity: user.work_preference,
      action:
        user.fld_username === null ||
        user.fld_username === "" ||
        user.fld_username === undefined
          ? "Add"
          : "Edit",
      username:
        user.fld_username === null ||
        user.fld_username === "" ||
        user.fld_username === undefined
          ? "Yes"
          : user.fld_username,
    };
    PostApiCall.postRequest(payload, "GenerateCredentialAuditor").then(
      (resultdes) =>
        resultdes.json().then((obj) => {
          if (resultdes.status == 200 || resultdes.status == 201) {
            setModal(!modal);
            toast.success(
              "Your account credentials have been sent to your register email address."
            );
            if (payload.username === "Yes") {
              dispatch(
                NotificationAction.addNotification({
                  title: "Auditor Onboard",
                  message: "Onboarding process completed by " + user?.fld_name,
                  linkurl: "",
                  usertype: "admin",
                  notificationtype: "Audit",
                  senderid: user.fld_id[0],
                  receiverid: 0,
                  updatedat: moment().format("ll"),
                })
              );
              dispatch(
                NotificationAction.addNotification({
                  title: "Auditor Onboard",
                  message:
                    "Your account login information has been successfully sent to your registered email address.",
                  linkurl: "",
                  usertype: "user",
                  notificationtype: "Audit",
                  senderid: 0,
                  receiverid: user.fld_id[0],
                  updatedat: moment().format("ll"),
                })
              );
            } else {
              dispatch(
                NotificationAction.addNotification({
                  title: "Auditor Onboard",
                  message: user?.fld_name + " account has been activated",
                  linkurl: "",
                  usertype: "admin",
                  notificationtype: "Audit",
                  senderid: user.fld_id[0],
                  receiverid: 0,
                  updatedat: moment().format("ll"),
                })
              );
            }
            socket.emit("FetchNotificationData");

            Notiflix.Loading.remove();
          } else {
            toast.error(obj.data);
            setModal(!modal);
            Notiflix.Loading.remove();
          }
        })
    );
  };

  function AuditorSubmit(value) {
    PostApiCall.postRequest(
      {
        id: value.fld_id,
        status: value.fld_auditstatus,
        recruiterremark: value.fld_recruiterremark,
        activeupto: value.fld_activeupto,
        updatedat: moment().format("ll"),
        updatedby: user.fld_id[0],
        auditorstatus: value.fld_auditorstatus,
      },
      "UpdateAuditRequest"
    )
      .then((results) => {
        return results.json().then((data) => {
          if (results.status === 200 || results.status === 201) {
            toast.success(`Audit Requset has been ${value.fld_auditorstatus}`, {
              autoClose: delay,
            });
            setTimeout(()=>{
              window.location.reload()
            },1000)
            setModal(false)
          }
        });
      })
      .catch((err) => console.log(err));
  }

  function CredentialModel() {
    return (
      <Modal
        isOpen={modal}
        backdrop={"static"}
        className={`modal-dialog-centered modal-md`}
        scrollable={false}
        // zIndex={10000}
      >
        <ModalHeader className="basebgColor text-light">
          Manage Audit
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="6">
              <FormGroup>
                <Label>Outlet Id</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={userData.fld_outletid}
                />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label>Outlet Name</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={userData.fld_outletname}
                />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label>City</Label>
                <Input readOnly type="text" defaultValue={userData.fld_city} />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label>Audit Schedule Date</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={moment(userData.fld_purposaldate).format("ll")}
                />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label>Audit Status</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={userData.fld_auditstatus}
                />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label>Auditor Status</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={userData.fld_auditorstatus}
                />
              </FormGroup>
            </Col>

            <Col sm="12">
              <FormGroup>
                <Label>Address</Label>
                <Input
                  readOnly
                  type="text"
                  defaultValue={userData.fld_address}
                />
              </FormGroup>
            </Col>
            <Col sm="12">
              <FormGroup>
                <Label>Auditor Remarks</Label>
                <Input
                  readOnly
                  type="textarea"
                  className="w-100 mt-1 p-2"
                  placeholder="message"
                  defaultValue={userData.fld_auditorremark}
                  style={{ height: "100px" }}
                />
              </FormGroup>
            </Col>
            <Col sm="12">
              <FormGroup>
                <Label>Recruiter Remarks</Label>
                <Input
                  readOnly
                  type="textarea"
                  className="w-100 mt-1 p-2"
                  placeholder="message"
                  defaultValue={userData.fld_recruiterremark}
                  style={{ height: "100px" }}
                />
              </FormGroup>
            </Col>
            {userData.fld_auditstatus === "Approved" && (
              <Col sm="12">
                <FormGroup>
                  <Label>Select Auditor Status</Label>
                  <Select
                    className=""
                    classNamePrefix="select"
                    placeholder="status"
                    name="color"
                    value={{
                      value: userData.fld_auditorstatus,
                      label: userData.fld_auditorstatus,
                    }}
                    options={[
                      { value: "Pending", label: "Pending" },
                      { value: "Accepted", label: "Accepted" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    onChange={(e) => {
                      setUserData((prev) => ({
                        ...prev,
                        fld_auditorstatus: e.value,
                      }));
                      setstatuschange("")
                    }}
                  />
                </FormGroup>
                {statuschange!=='' &&  <p className="text-danger font-size-3">{statuschange}</p>}
              </Col>
            )}
          </Row>
        </ModalBody>

        <ModalFooter className="bg-light">
          <Button className="cancelBtn" onClick={() => setModal(!modal)}>
            Cancel
          </Button>
          {userData.fld_auditstatus === "Approved" &&
            (userData.fld_auditpurpose === 1 ? (
              <Button
                className="basebgColor text-light px-3 py-1 rounded-3"
                onClick={() => {
                  if (userData.fld_auditstatus === "Approved") {
                    GenerateCreditHanlder(userData.fld_activeupto);
                  } else {
                    setModal(!modal);
                    Notify.warning("Audit request hasn't been approved yet.");
                  }
                }}
              >
                {user.fld_username === null ||
                user.fld_username === "" ||
                user.fld_username === undefined
                  ? "Generate Credential"
                  : "Resend Credential"}
              </Button>
            ) : (
              <Button
                className="basebgColor text-light px-3 py-1 rounded-3"
                onClick={() => {
                  if (userData.fld_auditorstatus !== statusOfAuditor) {
                    AuditorSubmit(userData);
                  } else {
                    setstatuschange('Please change the auditor status')
                  }
                }}
              >
                submit
              </Button>
            ))}
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <>
      <div>
        {getManageAuditData?.length > 0 ? (
          <div
            className="p-2 mt-2 container-fluid"
            style={{
              boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)",
              border: "none",
            }}
          >
            <Row className="filter-actions my-2 justify-content-between">
              <Col sm="12" md="3">
                <Input
                  style={{
                    border: "#cccccc solid 1px",
                    height: "38px",
                    borderRadius: "5px",
                  }}
                  className=" mr-1 shadow-sm"
                  type="text"
                  placeholder="search..."
                  value={searchKeyword}
                  onChange={handleSearch}
                />
              </Col>
              <Col sm="12" md="3">
                <div
                  className="dropdown actions-dropdown"
                  style={{ zIndex: 20 }}
                >
                  <Select
                    className=""
                    classNamePrefix="select"
                    placeholder="Filter by"
                    name="color"
                    options={[
                      { value: "All", label: "All" },
                      { value: "Reviewed", label: "Reviewed" },
                      { value: "Pending", label: "Pending" },
                      { value: "Approved", label: "Approved" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    value={jobStatus}
                    onChange={handleJobStatusChange}
                  />
                </div>
              </Col>
            </Row>

            <DataTable
              highlightOnHover
              className="dataTable-custom mt-2"
              data={filteredData}
              columns={columnDefs}
              fixedHeader
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              onRowClicked={(row) => {
                setUserData(row);
                setStatusOfAuditor(row.fld_auditorstatus);
                setModal(!modal);
              }}
              customStyles={{
                head: {
                  style: {
                    background: "transparent", // Remove the default background color
                  },
                },
                headRow: {
                  style: {
                    backgroundColor: "white",
                    color: "#ca8636",
                  },
                },
                headCells: {
                  style: {
                    fontSize: "14px",
                    textTransform: "capitalize",
                  },
                },
              }}
            />
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>
      {modal && CredentialModel()}
    </>
  );
};

export default ManageAudit;
